import * as t from "io-ts";
import { ApplicantDetails } from "./ApplicantDetails";
import { Archived } from "./Archived";
import { Budgets } from "./Budgets";
import { ConsumerSignature } from "./ConsumerSignature";
import { Customer } from "./Customer";
import { FlowType } from "./FlowType";
import { IntroductionState } from "./IntroductionState";
import { JobDetails } from "./JobDetails";
import { Metadata } from "./Metadata";
import { Signature } from "./Signature";
import { Trader } from "./Trader";
import { TraderDetails } from "./TraderDetails";

export const Introduction = t.intersection([
  t.type({
    consumer: Customer,
  }),
  t.partial({
    id: t.string,
    cid: t.string,
    oid: t.string,
    aid: t.string,
    eid: t.string,
    bid: t.string,
    tid: t.string,
    archived: Archived,
    remark: t.string,
    consumer_signature: ConsumerSignature,
    consumer_details: ApplicantDetails,
    budgets: Budgets,
    trader: Trader,
    trader_signature: Signature,
    trader_details: TraderDetails,
    job_details: JobDetails,
    current_state: IntroductionState,
    states: t.array(IntroductionState),
    flow_type: FlowType,
    xid: t.string,
    xref: t.string,
    metadata: Metadata,
  }),
]);

export interface Introduction {
  id?: string;
  cid?: string;
  oid?: string;
  aid?: string;
  eid?: string;
  bid?: string;
  tid?: string;
  archived?: Archived;
  remark?: string;
  consumer: Customer;
  consumer_signature?: ConsumerSignature;
  consumer_details?: ApplicantDetails;
  budgets?: Budgets;
  trader?: Trader;
  trader_signature?: Signature;
  trader_details?: TraderDetails;
  job_details?: JobDetails;
  current_state?: IntroductionState;
  states?: Array<IntroductionState>;
  flow_type?: FlowType;
  xid?: string;
  xref?: string;
  metadata?: Metadata;
}
